import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const httpHeaderInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const platformId = inject(PLATFORM_ID);
  if (isPlatformBrowser(platformId)) {
    const agentGuid = sessionStorage.getItem('agentGuid');
    if (!agentGuid) {
      return next(req);
    }
    const modifiedReq = req.clone({
      setHeaders: {
        'X-Loginid': JSON.parse(agentGuid),
      },
    });

    return next(modifiedReq);
  }
  return next(req);
};
